import { render, staticRenderFns } from "./addAdvertise.vue?vue&type=template&id=456625f0&scoped=true"
import script from "./addAdvertise.vue?vue&type=script&lang=js"
export * from "./addAdvertise.vue?vue&type=script&lang=js"
import style0 from "./addAdvertise.vue?vue&type=style&index=0&id=456625f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456625f0",
  null
  
)

export default component.exports